import { FormErrors } from "redux-form";

import { LoanEditFormData } from "../loanEditForm";
import {
    required,
    lessThanOrEqual,
    isNumeric,
    numberBetween,
} from "../../../../util/validators";
import moment from "moment";

const validateLoanEditForm = (values: LoanEditFormData) => {
    const errors: FormErrors<LoanEditFormData> = {};

    errors.loanNumber = required(values.loanNumber);
    errors.loanId = required(values.loanId);
    errors.editTypeId = required(values.editTypeId);
    errors.reasonAndDetails = required(values.reasonAndDetails);

    if (!values.contactByEmail && !values.contactByPhone) {
        errors.contactByEmail = required(values.contactByEmail);
        errors.contactByPhone = required(values.contactByPhone);
    }

    const changeType = Number(values.editTypeId);

    if (changeType === 1) {
        errors.maturityDate =
            required(values.maturityDate) ||
            isNumeric(values.maturityDate, null, null, null, true) ||
            numberBetween(values.maturityDate, 31, 1, "Eräpäivä väliltä 1-31");
    }

    if (changeType === 2) {
        errors.monthlyAmount = required(values.monthlyAmount);

        if (Number(values.monthlyAmount) <= 0) {
            errors.monthlyAmount = "Kuukausierän tulee olla suurempi kuin 0 €";
        }
    }

    if (changeType === 3) {
        errors.loanEndDate = required(values.loanEndDate);
    }

    if (changeType === 4) {
        errors.startDate = required(values.startDate);
        errors.endDate = required(values.endDate);

        let startDate = moment(values.startDate);
        let endDate = moment(values.endDate);
        if (startDate > endDate) {
            errors.endDate =
                "Päättymispäivä ei voi olla aikaisempi kuin aloituspäivä";
            errors.startDate = " ";
        }
    }

    return errors;
};

export default validateLoanEditForm;



// WEBPACK FOOTER //
// ./src/views/loan/components/validate/LoanEditFormValidator.tsx